module.exports = __webpack_public_path__ + "img/registration_button.cdccab82.png";